import PropTypes from "prop-types";

/* eslint-disable import/prefer-default-export */
export const message = PropTypes.oneOfType([
  // For pluralization - message should be an array of strings with length 3
  PropTypes.arrayOf((propertyValue) => {
    if (Array.isArray(propertyValue) && propertyValue.length !== 3) {
      throw new Error(
        `<TextMessage />: You passed in an array for TextMessage, which means you where probably trying to use pluralization. The message prop needs to be an array of three strings for valid pluralization. You passed in [${propertyValue}]`
      );
    }
  }),
  PropTypes.shape({
    message: PropTypes.string.isRequired,
  }),
  PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
    params: PropTypes.objectOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.func])
    ),
  }),
  PropTypes.string,
  PropTypes.number,
]);
